export const DEFAULT_HERO_IMAGES = [
  {
    url: 'https://images.unsplash.com/photo-1559314809-0d155014e29e?auto=format&fit=crop&w=1200&q=80',
    label: 'Pad Thai',
  },
  {
    url: 'https://images.unsplash.com/photo-1574484284002-952d92456975?auto=format&fit=crop&w=1200&q=80',
    label: 'Green Curry',
  },
  {
    url: 'https://images.unsplash.com/photo-1596040033229-a9821ebd058d?auto=format&fit=crop&w=1200&q=80',
    label: 'Thai Cuisine',
  },
];
